import { render, staticRenderFns } from "./Reviews.vue?vue&type=template&id=94353c56&"
import script from "./Reviews.vue?vue&type=script&lang=js&"
export * from "./Reviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports